function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from "react";
import PropTypes from "prop-types";
import useTheme from "../hooks/useTheme";
import { iconListMapping } from "./icon-list";
import { jsx as ___EmotionJSX } from "@emotion/core";
var NAMES = ["assistance", "arrow-back", "arrow-forward", "birthday", "blocking", "calculator", "call", "chevron-down", "chevron-left", "chevron-right", "chevron-up", "comparison", "critical", "cross-small", "cross", "devices", "document", "download", "duplicate", "edit", "external-link", "eye-hidden", "eye-visible", "face-id", "facebook", "fingerprint", "github", "hamburger", "home", "info-or-minor", "instagram", "link", "linkedin", "lock-small", "lock", "logout", "mail", "message", "notification-new", "notification", "overflow-menu", "payment", "person", "question", "search", "select-object", "shield", "stop", "stopwatch-alt", "stopwatch", "success", "tick-small", "tick", "time", "trash", "triangle-down", "triangle-up", "twitter", "warning-or-significant", "youtube"];
var SIZES = ["24px", "32px"];
var COLORS = ["black", "grey.t75", "primary.blue.t100", "highlight.blue.t100", "conditional.positive.graphics", "conditional.negative.graphics", "white"];
var HOVER_COLORS = ["black", "highlight.blue.t100", "secondary.lightBlue.t60"];
var SECONDARY_COLORS = ["highlight.blue.t100"];
var DEFAULT_PROPS = {
  size: "32px",
  color: "grey.t75",
  secondaryColor: "highlight.blue.t100"
};
Icon.NAMES = NAMES;
Icon.SIZES = SIZES;
Icon.COLORS = COLORS;
Icon.HOVER_COLORS = HOVER_COLORS;
Icon.SECONDARY_COLORS = SECONDARY_COLORS;
Icon.DEFAULT_PROPS = DEFAULT_PROPS;

function Icon(_props) {
  var props = _objectSpread(_objectSpread({}, DEFAULT_PROPS), _props);

  var name = props.name,
      size = props.size,
      color = props.color,
      hoverColor = props.hoverColor,
      secondaryColor = props.secondaryColor,
      testId = props.testId;
  var theme = useTheme();

  if (!NAMES.includes(name)) {
    return null;
  }

  var IconComponent = iconListMapping[name];
  return ___EmotionJSX(IconComponent, {
    size: size,
    primaryColor: theme.getColor(color),
    secondaryColor: theme.getColor(secondaryColor),
    hoverColor: theme.getColor(hoverColor),
    testId: testId
  });
}

Icon.propTypes = {
  name: PropTypes.oneOf(NAMES).isRequired,
  size: PropTypes.oneOf(SIZES),
  color: PropTypes.oneOf(COLORS),
  hoverColor: PropTypes.oneOf(HOVER_COLORS),
  secondaryColor: PropTypes.oneOf(SECONDARY_COLORS),
  testId: PropTypes.string
};
export default Icon;
/* 
  Tools used to simplify the icons:
  - https://svgomg.firebaseapp.com/
  - https://transform.tools/svg-to-jsx
*/